import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, Stack, Tooltip, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'

import {
  COLOR_NEGOTIATED,
  NEGOTIATION_OVERVIEW_FOOTNOTES,
  NEGOTIATION_OVERVIEW_INFO,
} from 'components/reports/Metrics/constants/NegotiationOverview'

import { NegotiationOverviewCards } from './NegotiationOverviewCards'
import { NegotiationOverviewFilterCriteria } from './NegotiationOverviewFilterCriteria'
import { NegotiationOverviewFiltersForm } from './NegotiationOverviewFilters'

export const NegotiationOverview = () => (
  <NegotiationOverviewFilterCriteria>
    <Box>
      <Stack
        direction={{ xs: 'column', lg: 'row' }}
        spacing={2}
        alignItems={{ xs: 'stretch', lg: 'flex-end' }}
        justifyContent='space-between'
        mb={3}>
        <Box sx={{ maxWidth: 480, flexShrink: 0, minWidth: { lg: 380 } }}>
          <Stack direction='row' spacing={1} alignItems='center'>
            <Typography variant='h5' fontWeight={700} sx={{ color: 'primary.main' }}>
              Negotiation Overview
            </Typography>
            <Tooltip
              title={NEGOTIATION_OVERVIEW_INFO}
              slotProps={{ tooltip: { sx: { whiteSpace: 'pre-line', maxWidth: 420 } } }}>
              <InfoOutlinedIcon fontSize='small' sx={{ color: 'text.disabled' }} />
            </Tooltip>
          </Stack>
          <Typography variant='body2' color='text.secondary'>
            Understand how often bids are negotiated and the magnitude of price changes.
          </Typography>
        </Box>

        <NegotiationOverviewFiltersForm />
      </Stack>

      <NegotiationOverviewCards />

      <Box
        sx={{
          mt: 3,
          px: 2,
          py: 1.5,
          borderRadius: 2,
          bgcolor: alpha(COLOR_NEGOTIATED, 0.04),
          border: 1,
          borderColor: alpha(COLOR_NEGOTIATED, 0.2),
        }}>
        <Stack direction='row' spacing={1.25} alignItems='flex-start'>
          <InfoOutlinedIcon sx={{ fontSize: 18, color: COLOR_NEGOTIATED, mt: 0.25 }} />
          <Box>
            {NEGOTIATION_OVERVIEW_FOOTNOTES.map((line) => (
              <Typography
                key={line}
                variant='caption'
                color='text.secondary'
                display='block'
                sx={{ lineHeight: 1.7 }}>
                {line}
              </Typography>
            ))}
          </Box>
        </Stack>
      </Box>
    </Box>
  </NegotiationOverviewFilterCriteria>
)
